import React from 'react';

import PropTypes from 'prop-types';

import {
    CarrierLogo,
    Typography,
} from 'wanderu-components';

import styles from './CarrierTitle.scss';

function CarrierTitle(props) {
    const {
        carrierCardTitle,
        carrierCode,
        carrierName,
    } = props;

    return (
        <div className={styles.root}>
            <span className={styles.carrierLogo}>
                <CarrierLogo
                    carrierCode={carrierCode}
                    carrierName={carrierName}
                    lazyload={false}
                />
            </span>
            <Typography component="h3">
                {carrierCardTitle}
            </Typography>
        </div>
    );
}

CarrierTitle.propTypes = {
    carrierCardTitle: PropTypes.string.isRequired,
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string.isRequired,
};

export default CarrierTitle;
